"use client"

import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

export default function AccessDenied() {
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Access denied</Title>
      <Paragraph>
        Please log in with appropriate credentials to access this page.
      </Paragraph>
    </div>
  );
}